import { requiredString } from '@wyz/utils';
import { z } from 'zod';

export const criteriaFormSchema = z.object({
  name: requiredString,
});
export const createCriteriaFormSchema = criteriaFormSchema.extend({
  values: z.array(z.object({ label: z.string().min(1) })).min(1),
  visible: z.boolean(),
});

export const criteriaPayloadSchema = criteriaFormSchema.extend({
  visible: z.boolean(),
  values: z.array(
    z.object({
      id: z.string().optional(),
      label: z.string(),
    }),
  ),
});
export const criteriaSchema = criteriaFormSchema.extend({
  id: z.string(),
  translatedName: z.string().nullable(),
  code: z.enum(['AUTOMAKER_GROUP', 'COUNTRY']).nullish(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
  values: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
      default: z.boolean(),
    }),
  ),
  isReserved: z.boolean().nullish(),
  visible: z.boolean(),
});

export const criteriaCheckUsageSchema = z.object({
  criteria: z.array(
    z.object({
      criterion: z.string(),
      values: z.array(z.string()),
    }),
  ),
});
